import { Injectable } from "@angular/core";
import { AuthService } from "@edpc/edp-auth";
import { Observable, of } from "rxjs";
import { ApiService } from "./api.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "@edp-environments/environment";
import { CookieService } from "ngx-cookie-service";
import { catchError, switchMap } from "rxjs/operators";
import { RuleType } from "@edp-models/deep-link.model";
import { Contract } from "@edp-components/edp-contract";
import { EdpUser } from "@edp-models/user.model";
import { DeviceDetectorService } from "ngx-device-detector";
import { RegionService } from "./region.service";

@Injectable({
    providedIn: "root",
})
export class AuthenticationService {
    constructor(
        private auth: AuthService,
        private readonly http: HttpClient,
        private apiService: ApiService,
        private cookieService: CookieService,
        private deviceDetector: DeviceDetectorService,
        private regionService: RegionService
    ) { }

    public validateToken(token: string, isImpersonate: boolean) {
        const platform = environment.isApp ? 2 : this.deviceDetector.isMobile() ? 1 : 0;
        const region = this.regionService.getRegion();

        return this.apiService.callServicePost("usersession.login", { token_id: token, isImpersonate, platform, region });
    }

    private clearStorage(): void {
        localStorage.removeItem("user-tob-bar");
        sessionStorage.removeItem("sent-reading-whatsnew");
        sessionStorage.removeItem("counter-dashboard-fail");
    }

    public logout(): Observable<any> {
        this.clearStorage();

        return this.http.post(`${environment.apiUrl}usersession.logOff`, {}).pipe(
            switchMap(() => {
                this.cookieService.delete("is_impersonate");
                return this.auth.logout("sso");
            }),
            catchError(() => of(true))
        );
    }

    public hasAccess(ruleType: RuleType, contract: Contract, user?: EdpUser): boolean {
        switch (ruleType) {
            case RuleType.FUNCIONA:
            case RuleType.SERVICO:
                if (contract.HasPack ||
                    contract.HasServiceFunciona ||
                    contract.HasServiceFuncionaCA) {
                    return true;
                }
                break;
            case RuleType.SAUDE:
                if (contract.HasPack) {
                    return contract.HasPack.full;
                }
                break;
            case RuleType.PLANETA:
                if (user && user.edpESubscribed) {
                    return true;
                }
                break;
            case RuleType.DEFAULT:
                return true;
            default:
                break;
        }
        return false;
    }
}
